// src/hooks/useMentorAssignedAck.js
// Detecta si al discípulo le asignaron mentor desde la última vez que lo confirmó (dismiss).
// El ack vive en profile.mentorAckedId (Firestore), no en localStorage — un ack por
// navegador reaparecía cada vez que la persona entraba desde un dispositivo o
// navegador distinto. Usado por el banner "Ya tienes acompañante" de /mi-cuenta/
// (antes /discipulo/, fusionado en U3) y por el punto dorado del ícono de cuenta en
// Layout.js (ver project-log/sesiones/S02-puerta-acompanamiento.md).

import { useState, useEffect } from "react";
import { ackMentorAssigned } from "../services/auth-service";

export function useMentorAssignedAck(uid, mentorId, mentorAckedId) {
  const [pending, setPending] = useState(false);
  const hasMentor = !!mentorId;

  useEffect(() => {
    setPending(hasMentor && mentorAckedId !== mentorId);
  }, [hasMentor, mentorId, mentorAckedId]);

  function dismiss() {
    setPending(false);
    if (uid && mentorId) {
      ackMentorAssigned(uid, mentorId).catch((err) => console.error("[mentorAck]", err));
    }
  }

  return { pending, dismiss };
}
